import React, { forwardRef } from 'react';
import CustomDateTimeInput from './CustomDateTimeInput';
import { ClearButton } from 'shared/buttons';
import BaseLabel from '../../labels/BaseLabel';
import isNil from 'lodash/isNil';

/**
 * @typedef {React.ComponentPropsWithoutRef<CustomDateTimeInput>} CustomDateTimeInputProps
 *
 * @param {CustomDateTimeInputProps} props
 * @param {React.Ref<HTMLDivElement>} ref
 * @returns {React.ReactElement}
 */
const BaseDateTimeInput = ({ width, label, ...props }, ref) => {
  const { onChange } = props;
  const onClear = () => onChange({ value: null });
  return (
    <span className='k-widget k-dateinput base-date-input' {...(!isNil(width) ? { style: { width } } : {})}>
      {label && <BaseLabel editorRef={ref}>{label}</BaseLabel>}
      <span className='k-dateinput-wrap'>
        <CustomDateTimeInput ref={ref} {...props} />
        <ClearButton onClick={onClear} tabIndex={-1} />
      </span>
    </span>
  );
};

/**
 * A base datetime input component.
 *
 * @param {CustomDateTimeInputProps} props - Component props. Extends CustomDateTimeInput props.
 * @param {React.Ref<HTMLDivElement>} ref
 * @returns {React.ReactElement} Base datetime input component.
 */
const ForwardDateTimeInput = forwardRef(BaseDateTimeInput);

export default ForwardDateTimeInput;
